/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/close-pink': {
    width: 22,
    height: 21,
    viewBox: '0 0 22 21',
    data: `
            <rect x="3" y="0.0539246" width="25.5349" height="3.95952" transform="rotate(45 3 0.0539246)" fill="#FF5786"/>
            <rect y="18.0559" width="25.5349" height="3.97674" transform="rotate(-45 0 18.0559)" fill="#FF5786"/>
        `
  }
})
